/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["@media only screen and (max-width:768px){[_nghost-%COMP%]     .ant-tree{overflow:auto}[_nghost-%COMP%]     .ant-tree li{padding:4px 0 0;font-size:14px}}"];
export { styles as styles };
